import(/* webpackMode: "eager", webpackExports: ["ServicesContent"] */ "/vercel/path0/src/components/services/ServicesContent.tsx");
